module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "home-wrapBackground u-posFullScreen"
  }, [_c('base-video', {
    attrs: {
      "placeholder-src": "/static/loop-placeholder.jpg",
      "src": _vm.loopSrc
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inner",
    attrs: {
      "id": "titles"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("\n      Paul"), _c('br'), _vm._v("\n      Thibault\n    ")]), _vm._v(" "), _c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("filmmaker")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8eb5231c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/HomeView.vue
// module id = 177
// module chunks = 1